module.exports = __webpack_public_path__ + "img/Pure_Storage_Logo.96838126.png";